import { MapCard } from './MapCard';

export type { TypeMapCardProps } from './types';
export default MapCard;
